import { useEffect, useState } from 'react';
import { useToast } from '../../../shared/hooks/use-toast';
import { getAccountingPeriodRule, setAccountingPeriodRule } from '../accounting-periods.api';

/** The tenant's period start day: `null` until it loads. Saving it changes periods created afterwards, never an existing one. */
export function usePeriodRule(enabled: boolean) {
  const [startDay, setStartDay] = useState<number | null>(null);
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    getAccountingPeriodRule()
      .then((rule) => {
        if (!cancelled) setStartDay(rule.startDay);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  async function save(next: number): Promise<void> {
    setSaving(true);
    try {
      setStartDay((await setAccountingPeriodRule(next)).startDay);
      toast.success(`Periods now start on day ${next}`);
    } catch {
      toast.error("Couldn't save the period start day");
    } finally {
      setSaving(false);
    }
  }

  return { startDay, saving, save };
}
